// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.intersect-block[data-v-21ca72ac]{opacity:0;transform:translateY(5rem);transition:opacity .5s ease,transform .5s ease}.intersect-block.active[data-v-21ca72ac]{opacity:1;transform:translateZ(0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
